import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

import Card from "@molecules/Card/Card"

function getCategoryPosts(posts, categoryID) {
  return posts
    .filter((item) => {
      const postCategoryIDs = item.node.categories.nodes.map((category) => {
        return category.id
      })
      return postCategoryIDs.some((id) => id === categoryID) ? item : false
    })
    .filter(Boolean)
}

const LatestPosts = ({ blockDataLatestPosts }) => {
  const { heading, category1, category2, category3 } =
    blockDataLatestPosts || {}

  const data = useStaticQuery(
    graphql`
      {
        latestPosts: allWpPost(limit: 500, sort: { date: DESC }) {
          edges {
            node {
              id
              categories {
                nodes {
                  id
                  name
                  slug
                }
              }
              title
              uri
              featuredImage {
                node {
                  mediaDetails {
                    width
                    height
                  }
                  cloudinaryDetails {
                    public_id
                    original_filename
                    format
                  }
                  sourceUrl
                  altText
                  altTextOriginal
                }
              }
            }
          }
        }
      }
    `
  )

  const posts = data.latestPosts.edges

  const id1 = category1?.id
  const id2 = category2?.id
  const id3 = category3?.id

  const category1Posts = getCategoryPosts(posts, id1)
  const category2Posts = getCategoryPosts(posts, id2)
  const category3Posts = getCategoryPosts(posts, id3)

  const index1 = 0
  const index2 = id1 === id2 ? 1 : 0
  const index3 =
    id1 === id2 && id1 === id3 ? 2 : id1 === id3 || id2 === id3 ? 1 : 0

  const postsMerged = [
    category1Posts[index1]?.node,
    category2Posts[index2]?.node,
    category3Posts[index3]?.node,
  ].filter(Boolean)

  const postsMapped = postsMerged.map((item, index) => {
    return (
      <Col key={index} md="4">
        <Card
          headingSize={heading ? "h3" : "h2"}
          image={item.featuredImage ? item.featuredImage.node : false}
          imageAspectRatio={"16:9"}
          tagline={item.categories.nodes[0].name}
          title={item.title}
          url={item.uri}
          internalLink={true}
        />
      </Col>
    )
  })

  return (
    <section className="base-margin-top-xl base-margin-bottom-large text-align-left">
      {heading && (
        <div className="base-margin-bottom-small">
          <h2>{heading}</h2>
        </div>
      )}
      <Row className="mobile-bottom-margins">{postsMapped}</Row>
    </section>
  )
}

export const query = graphql`
  fragment LatestPosts on WpBlockAcfLatestPosts {
    __typename
    blockDataLatestPosts {
      heading
      category1 {
        id
      }
      category2 {
        id
      }
      category3 {
        id
      }
    }
  }
`
export default LatestPosts
